document.addEventListener('DOMContentLoaded', function () {
  const SearchPane = {}

  SearchPane.init = function () {
    let isAutocompleted = false
    let originalAutocomplete = ''
    let originalUserInput = ''
    let originalPreappend = ''
    let searchTimeout
    let results = []
    let otherOptions = []
    // Tracks which pickup selection "owns" the current dropoff list.
    // Every time pickup state is reset or a new pickup is confirmed, we increment this value.
    // Any async dropoff fetch that resolves with an older request id is ignored, which prevents
    // stale search responses from a previous pickup from polluting the latest dropoff options.
    let activeDropoffRequestId = 0

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
    }

    function isEntireInputSelected(inputElem) {
      return inputElem.selectionStart === 0 && inputElem.selectionEnd === inputElem.value.length
    }

    function debounce(func, wait) {
      let timeout
      return function (...args) {
        const context = this
        clearTimeout(timeout)
        timeout = setTimeout(() => func.apply(context, args), wait)
      };
    }

    const debouncedSearch = debounce(function (e) {
      clearTimeout(searchTimeout)
      searchTimeout = setTimeout(function () {
        const inputElem = e.target
        const currentInput = inputElem.value.trim()
        const cursorPosition = inputElem.selectionStart
        const actualInput = currentInput.substring(0, cursorPosition)

        if (actualInput !== '' && actualInput.length > 1) {
          searchLocations(actualInput, 5, function (topSuggestion) {
            const refreshedInput = inputElem.value.trim()
            const refreshedCursorPosition = inputElem.selectionStart

            if (refreshedInput.substring(0, refreshedCursorPosition) !== actualInput) {
              return
            }

            originalUserInput = actualInput

            if (!topSuggestion) {
              inputElem.value = capitalizeFirstLetter(refreshedInput)
              resetSearchValues()
              inputElem.setSelectionRange(refreshedCursorPosition, refreshedCursorPosition)
              return
            }

            const locale = getLocale()
            const itemName = getLocalisedString(locale, topSuggestion)


            if (topSuggestion && itemName.toLowerCase().startsWith(currentInput.toLowerCase()) && !isAutocompleted) {
              const remainingSuggestion = itemName.slice(currentInput.length)
              originalPreappend = remainingSuggestion
              isAutocompleted = true
              originalAutocomplete = topSuggestion
              inputElem.value = capitalizeFirstLetter(currentInput + remainingSuggestion)
              inputElem.setSelectionRange(refreshedCursorPosition, inputElem.value.length)
            } else {
              const lowerUserInput = actualInput.toLowerCase()
              const lowerSuggestion = itemName.toLowerCase()

              const index = lowerSuggestion.indexOf(lowerUserInput)

              if (index !== -1) {
                isAutocompleted = true
                originalAutocomplete = itemName
                inputElem.value = itemName
                inputElem.setSelectionRange(index + actualInput.length, inputElem.value.length)
              } else {
                inputElem.value = capitalizeFirstLetter(refreshedInput)
                resetSearchValues()
                inputElem.setSelectionRange(refreshedCursorPosition, refreshedCursorPosition)
              }
            }
          })
        }
      }, 500)
    })

    function toggleOptions(input) {
      if (input.classList.contains('d-none')) {
        input.classList.remove('d-none')
        input.classList.add('d-block')
      } else if (input.classList.contains('d-block')) {
        input.classList.remove('d-block')
        input.classList.add('d-none')

        if (input.id === 'promo-code-input') {
          document.getElementById('promo-code').value = ''
        }
      }
    }

    function toggleInputDisplay(componentSelector, inputSelector) {
      const component = document.querySelector(componentSelector)
      const input = document.querySelector(inputSelector)

      if (component) {
        component.addEventListener('change', function () {
          toggleOptions(input)
        })
      }
    }

    function checkInputSetup() {
      toggleInputDisplay('#promo-check', '#promo-code-input')
      toggleInputDisplay('#age-check', '#age-input')
    }

    function closeResultsIfClickOutside(pickupResults, dropoffResults, pickupSearch, dropoffSearch) {
      document.addEventListener('click', function (event) {
        const showMoreBtn = document.getElementById('show-more-locations-button')

        if (pickupResults && (event.target !== pickupResults && event.target !== pickupSearch && event.target !== showMoreBtn)) {
          if (pickupResults.classList.contains('d-block')) {
            pickupResults.classList.remove('d-block')
            pickupResults.classList.add('d-none')
          }
        }

        if (dropoffResults && (event.target !== dropoffSearch && event.target !== dropoffResults)) {
          if (dropoffResults.classList.contains('d-block')) {
            dropoffResults.classList.remove('d-block')
            dropoffResults.classList.add('d-none')
          }
        }
      })
    }

    function setUpSearchInputs() {
      const pickupSearch = document.getElementById('pickup-algoliaSearch')
      const pickupResults = document.getElementById('searchResults')
      const dropoffSearch = document.getElementById('dropoff-algoliaSearch')
      const dropoffResults = document.getElementById('dropoff-searchResults')

      if (pickupSearch) {
        pickupSearch.addEventListener('input', function (e) {
          hideDropoff()
          resetSearchValues()
          if (searchTimeout) {
            clearTimeout(searchTimeout)
          }

          if (pickupResults.classList.contains('d-none')) {
            pickupResults.classList.remove('d-none')
            pickupResults.classList.add('d-block')
          }

          debouncedSearch(e)
        })

        pickupSearch.addEventListener('keydown', function (event) {
          hideDropoff()
          if (event.keyCode === 8) {
            if (isEntireInputSelected(pickupSearch)) {
              event.target.value = ''
            } else {
              if (originalPreappend.length) {
                event.target.value = event.target.value.slice(0, event.target.value.length - originalPreappend.length)
              }
              if (event.target.value === '') {
                isAutocompleted = false
                originalAutocomplete = ''
              }
            }
          }
        })

        pickupSearch.addEventListener('paste', function (e) {
          hideDropoff()
          isAutocompleted = false

          setTimeout(() => {
            debouncedSearch(e)
          }, 0)
        })

        pickupSearch.addEventListener('cut', function (e) {
          hideDropoff()
          // clear all input let them start again
          event.target.value = ''
        })
      }

      if (dropoffSearch) {
        dropoffSearch.addEventListener('click', function (e) {
          if (pickupSearch.value) {
            toggleOptions(dropoffResults)
          } else {
            pickupSearch.focus()
          }
        })
      }

      closeResultsIfClickOutside(pickupResults, dropoffResults, pickupSearch, dropoffSearch)
    }

    function showMoreResults() {
      const showMoreBtn = document.getElementById('show-more-locations-button')
      const pickupSearch = document.getElementById('pickup-algoliaSearch')
      const pickupResults = document.getElementById('searchResults')

      if (showMoreBtn) {
        showMoreBtn.addEventListener('click', function (e) {
          pickupSearch.scrollIntoView({ behavior: 'smooth', block: 'start' })

          pickupResults.classList.remove('d-none')
          pickupResults.classList.add('d-block')

          searchLocations(originalUserInput, 100)
        })
      }
    }

    function clearDropoffResults() {
      const dropoffResultsDropdownSet = document.getElementById('dropoff-suggestions')

      dropoffResultsDropdownSet.innerHTML = ''
    }

    function isValidDate(dateTimeString) {
      const regex = /^\d{4}-\d{2}-\d{2}$/

      if (!regex.test(dateTimeString)) {
        return false
      }

      return moment(dateTimeString, 'YYYY-MM-DD', true).isValid() ? dateTimeString : false
    }

    function isValidTime(timeString) {
      const regex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/

      return regex.test(timeString) ? timeString : false
    }

    function isValidPromoCode(promoCode) {
      const regex = /^\d{8}[A-Z0-9]{7}$/

      if (!promoCode) return true

      const test = regex.test(promoCode) ? promoCode : false

      if (test === false) {
        document.getElementById('promo-code').value = ''
      }

      return test
    }

    function isValidLocation(location) {
      const regex = /^(?!0)\d+$/

      return regex.test(location) ? location : false
    }

    function isValidAge(age) {
      const regex = /^(?:1[01][0-9]|150|0|[1-9][0-9]?)$/
      return regex.test(age) ? age : false
    }

    function displayErrors(errors) {
      const errorDiv = document.createElement('div')
      const errorsDIv = document.getElementById('errors')

      document.getElementById('errors').innerHTML = ''

      errorDiv.className = 'alert alert-danger'
      errorDiv.innerHTML = errors.join('<br>')

      errorsDIv.scrollIntoView({ behavior: 'smooth', block: 'start' })

      document.getElementById('errors').appendChild(errorDiv)
    }

    function clearErrors() {
      const errorsDiv = document.getElementById('errors')
      errorsDiv.innerHTML = ''
    }

    function endDateAfterStartDate(errors, formData) {
      const startDate = new Date(`${formData.start_date}T${formData.start_time}`)
      const endDate = new Date(`${formData.end_date}T${formData.end_time}`)

      if (endDate <= startDate) {
        errors.push(window.language.search.dates_before)
      }
    }

    function getInvalidFields(data) {
      const errors = []
      let invalidForm = false

      for (const key in data) {
        if (!data[key] && key !== 'cancel_donation') {
          errors.push(`${window.language.search[key]} ${window.language.search.validation.invalid}`)
        }
      }

      endDateAfterStartDate(errors, data)

      if (errors.length > 0) {
        displayErrors(errors)
        invalidForm = true
      }

      return invalidForm
    }

    function isValidLastName(lastName) {
      const regex = /^[\p{L}\s'’\-]+$/u
      return regex.test(lastName) && lastName.length >= 1 && lastName.length <= 50 ? lastName : false
    }

    function handleFormErrors(error) {
      const errors = []

      // If the error object has a message, add it to the errors array
      if ('fields' in error) {
        for (const key in error.fields) {
          if (error.fields[key].name === 'promo_code') {
            error.fields[key].name = 'promo'
          }

          if (typeof window.language.search[error.fields[key].name] === 'undefined') {
            errors.push(window.language.search.something_wrong)
          } else {
            errors.push(`${window.language.search[error.fields[key].name]} ${window.language.search.validation.invalid}`)
          }
        }
      } else {
        if (typeof error.code !== 'undefined') {
          errors.push(error.message)
        } else {
          errors.push(window.language.search.something_wrong)
        }
      }

      displayErrors(errors)
    }

    function isValidBookingReference(bookingRef) {
      const regex =/^[A-Za-z]+(?:\([A-Za-z]\))?-\d+-\d+$/

      return regex.test(bookingRef) ? bookingRef : false
    }

    function setUpBtn(button) {
      button.innerHTML = '<div class="loader"></div>'
      button.disabled = true
    }

    function resetBtn(button) {
      button.innerHTML = 'Search'
      button.disabled = false
    }

    function toggleFranchise(franchiseInputs, locationsInputs) {
      if (franchiseInputs.classList.contains('d-none')) {
        franchiseInputs.classList.remove('d-none')
        franchiseInputs.classList.add('d-block')

        locationsInputs.classList.remove('d-block')
        locationsInputs.classList.add('d-none')
      } else {
        franchiseInputs.classList.remove('d-block')
        franchiseInputs.classList.add('d-none')

        locationsInputs.classList.remove('d-none')
        locationsInputs.classList.add('d-block')
      }
    }

    function getFranchise() {
      const franchiseInputs = document.getElementById('franchise-input')
      const franchiseSelect = document.getElementById('franchise-select')
      const locationsInputs = document.getElementById('locations-input')

      if (window.language.is_franchise && franchiseInputs && locationsInputs) {
        const button = document.getElementById('algolia-submit-btn')

        if (franchiseInputs.hasAttribute('data-default-franchise-country')) {
          franchiseInputs.classList.remove('d-none')
          franchiseInputs.classList.add('d-flex')
          button.disabled = false
        } else if (franchiseSelect) {
          button.disabled = true

          toggleFranchise(franchiseInputs, locationsInputs)

          franchiseSelect.addEventListener('click', function () {
            toggleFranchise(franchiseInputs, locationsInputs)
            button.disabled = false
          })
        }
      }
      // the below slows down form loading by more than a second, possibly more or less.
      /*
              fetchData(window.core_api_endpoint + 'api/countries')
                .then(data => {
                  const franchise = data.find(country => {
                    return country.id == countryId
                  });

                  if (franchise) {
                    toggleFranchise(franchiseInputs, locationsInputs)

                    franchiseSelect.addEventListener('click', function (e) {
                      toggleFranchise(franchiseInputs, locationsInputs)
                    })
                  }
                });
            }
             */
    }

    function fetchCountryId() {
      window.countryId = ''

      const locationsInputs = document.getElementById('locations-input')
      const shouldFilterByFranchiseCountry = !locationsInputs ||
        !locationsInputs.hasAttribute('data-franchise-country-search') ||
        locationsInputs.dataset.franchiseCountrySearch === 'true'

      if (window.language.is_franchise && shouldFilterByFranchiseCountry) {
        const countryIdentifier = window.siteHandle || window.language.accept_language

        fetchData(window.core_api_endpoint + `api/countries/${encodeURIComponent(countryIdentifier)}`)
          .then(data => {
            if (typeof data !== 'undefined' && typeof data.id !== 'undefined') {
              window.countryId = data.id
            } else {
              throw new Error('No country data found.')
            }
          })
          .catch(error => {
            console.error('An error occurred:', error)
          })
      }
    }

    function fetchData(url) {
      return fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
      })
        .then(response => response.json())
        .then(data => {
          return data.data
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error.message)
          return null
        })
    }

    function getCookie(name) {
      const cookies = document.cookie.split(';');

      for (let cookie of cookies) {
        cookie = cookie.trim();

        if (cookie.startsWith(name + '=')) {
          return cookie.substring(name.length + 1);
        }
      }

      return null;
    }

    function getParams(opts) {
      const urlParams = []
      const queryString = window.location.search.substring(1) // Exclude the "?" character
      const paramPairs = queryString.split('&')

      let filters = {
        size: null,
        passengers: null,
        fuel_type: null,
        transmission: null,
        min_price: null,
        max_price: null,
        puid: null,
        duid: null,
        promo: null,
      }

      for (const pair of paramPairs) {
        const [key, value] = pair.split('=')
        if (key !== undefined && value !== undefined) {
          urlParams.push([key, decodeURIComponent(value.replace(/\+/g, ' '))])
        }
      }

      for (const [paramName, value] of urlParams) {
        if (filters.hasOwnProperty(paramName)) {
          filters[paramName] = encodeURIComponent(value)
        }
      }

      const filterParams = Object.entries(filters)
        .filter(([key, value]) => value)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&')

      if (filterParams) {
        opts.push(filterParams)
      }

      return opts
    }

    function redirectToCarTrawlerEngine(pickupLocation, dropoffLocation, pickupDateTime, dropoffDateTime, driverAge) {
      const parameters = {
        pickupLocationId: pickupLocation?.car_trawler_id,
        returnLocationId: dropoffLocation?.car_trawler_id,
        age: driverAge,
        pickupDateTime: pickupDateTime,
        returnDateTime: dropoffDateTime
      }

      const queryString = Object.keys(parameters)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key]))
        .join('&')

      const path = `ct-quotes?${queryString}`

      window.location.href = window.bookingUrl + path
    }

    function formSubmit(formData, formAddr, windowLocation, checkVar, button) {
      // Replace domain extension for franchises
      const domainExtension = location.host.split('.')[location.host.split('.').length - 1]
      windowLocation = windowLocation.replace(/\.com(?=\/)/, '.' + domainExtension)

      const invalidFields = getInvalidFields(formData)
      const userTokenCookie = getCookie('search_user_token')

      let headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }

      if (userTokenCookie) {
        const userToken = `${decodeURIComponent(userTokenCookie)}`

        const jsonObject = JSON.parse(userToken)
        const accessToken = jsonObject.access_token

        headers.Authorization = 'Bearer ' + accessToken
      }

      // Get locations for cartrawler check
      const pickupSelectedId = document.getElementById('pickup-algoliaSearch-data').value
      const dropoffSelectedId = document.getElementById('dropoff-algoliaSearch-data').value

      const pickupLocation = results.filter(location => location.id == pickupSelectedId)?.[0]
      const dropoffLocation = otherOptions.filter(location => location.id == dropoffSelectedId)?.[0]

      // Redirect to Cartrawler
      if (pickupLocation?.provider === 'CTR') {
        return redirectToCarTrawlerEngine(
          pickupLocation,
          dropoffLocation,
          moment.parseZone(`${document.getElementById('pickup-date-value').value} ${document.getElementById('pickup-time-value').value}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm:ss'),
          moment.parseZone(`${document.getElementById('dropoff-date-value').value} ${document.getElementById('dropoff-time-value').value}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm:ss'),
          document.getElementById('age').value
        )
      }

      if (!invalidFields) {
        fetch(formAddr, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(formData)
        })
          .then(response => {
            if (!response.ok) {
              return response.json().then(errorData => {
                handleFormErrors(errorData.error)
                resetBtn(button)

                throw new Error('Server responded with an error: ' + JSON.stringify(errorData))
              })
            }

            return response.json()
          })
          .then(data => {
            if (checkVar === 'id') {
              data = data.data
            }

            resetBtn(button)

            if (checkVar in data) {
              let location = windowLocation + data[checkVar]

              // If the booking belongs to a user, we need to change the URL to /user/bookings/
              if (data.has_user) {
                location = location.replace('/guest/bookings/', '/user/bookings/')
              }

              // If the booking can be modified, redirect to edit page
              if (data.can_be_modified && data.is_authenticated) {
                location += '/edit'
              }

              // If the booking belongs to a user and the current user is not authenticated, we need to redirect to the login page
              if (data.has_user && !data.is_authenticated) {
                window.location.href = window.core_booking_app_endpoint + 'user'
                return;
              }

              // if the booking belongs to a user and the current user is authenticated but is not the owner of the booking, we need to redirect to the bookings page
              if (data.has_user && data.is_authenticated && !data.is_booking_owner) {
                window.location.href = window.core_booking_app_endpoint + 'user/bookings'
                return;
              }

              let opts = []

              if ('guest_token' in data && data.guest_token !== null) {
                opts.push(`gt=${data.guest_token}`)
              }

              if ('currency' in data && data.currency !== null) {
                opts.push(`c=${data.currency}`)
              }

              opts = getParams(opts)

              if (opts.length) {
                location = location + '?' + opts.filter(Boolean).join('&')
              }

              if (data.walk_in_location === 1) {
                window.location.href = 'locations/' + data.pickup_location_id
              } else {
                window.location.href = location
              }
            }
          })
          .catch(error => {
            resetBtn(button)

            console.error('There was a problem with the fetch operation:', error.message)
          })
      } else {
        resetBtn(button)
      }
    }
    function getSearchIndexName() {
      return `${window.algolia.index}locations`
    }

    function resolveLocationSearchDriver() {
      const searchOptions = (window.greenmotion && window.greenmotion.search) ? window.greenmotion.search : {}
      const driver = searchOptions.locationSearchDriver || searchOptions.searchDriver || searchOptions.driver || 'algolia'

      return String(driver).toLowerCase()
    }

    function getSearchRecordsEndpoint() {
      const base = window.core_api_endpoint || '/'
      const normalisedBase = base.endsWith('/') ? base : `${base}/`
      return `${normalisedBase}api/search/indexes/${encodeURIComponent(getSearchIndexName())}/records`
    }

    function getSearchResultsFromResponse(payload) {
      if (!payload) {
        return []
      }

      if (Array.isArray(payload)) {
        return payload
      }

      if (Array.isArray(payload.hits)) {
        return payload.hits
      }

      if (Array.isArray(payload.results)) {
        return payload.results
      }

      if (Array.isArray(payload.records)) {
        return payload.records
      }

      if (payload.data) {
        return getSearchResultsFromResponse(payload.data)
      }

      return []
    }

    function searchViaApi(params = {}) {
      return fetch(getSearchRecordsEndpoint(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(params)
      })
        .then(response => response.json())
        .then(data => getSearchResultsFromResponse(data))
    }

    function searchViaAlgolia(params = {}) {
      const query = typeof params.q === 'undefined' ? '' : params.q
      const hitsPerPage = typeof params.per_page === 'undefined' ? 5 : params.per_page
      const filters = typeof params.filters === 'undefined' ? '' : params.filters

      return fetch('/actions/algolia/default/search', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': window.csrf
        },
        body: JSON.stringify({
          index: getSearchIndexName(),
          query: query,
          params: {
            hitsPerPage: hitsPerPage,
            filters: filters,
          }
        })
      })
        .then(response => response.json())
        .then(data => getSearchResultsFromResponse(data))
    }

    function fetchSearchRecords(params = {}) {
      const driver = resolveLocationSearchDriver()

      if (driver === 'api') {
        return searchViaApi(params)
      }

      return searchViaAlgolia(params)
    }

    function buildObjectFilters(objectID) {
      const normalisedObjectId = String(objectID || '')

      if (!normalisedObjectId) {
        return ''
      }

      const objectIdParts = normalisedObjectId.split('_')
      const idCandidate = objectIdParts.length > 1 ? objectIdParts[objectIdParts.length - 1] : normalisedObjectId

      return `(objectID:${normalisedObjectId} OR id:${normalisedObjectId} OR id:${idCandidate})`
    }

    function resetDropoffOptions() {
      // Invalidate every in-flight dropoff request from the previous pickup context, then clear
      // both the in-memory option cache and the rendered dropdown. This is called whenever the
      // user starts changing the pickup field or when we need to rebuild dropoff options fresh.
      activeDropoffRequestId += 1
      otherOptions = []
      clearDropoffResults()
    }

    async function fetchObject(objectID, requestId = activeDropoffRequestId) {
      try {
        const records = await fetchSearchRecords({
          q: '',
          per_page: 1,
          filters: buildObjectFilters(objectID),
        })

        // Ignore late responses that belong to an older pickup selection. Without this guard,
        // a slow response from a previous search can append incorrect dropoff locations after
        // the user has already moved on and selected a different pickup location.
        if (requestId !== activeDropoffRequestId) {
          return
        }

        if (records.length > 0) {
          setDropOff(records[0], requestId)
        }
      } catch (err) {
        console.error(err)
      }
    }

    function setDropOff(content, requestId = activeDropoffRequestId) {
      // Same protection as above, but at render time. Even if an outdated caller reaches this
      // function, it should not mutate `otherOptions` or the dropdown for the active pickup.
      if (requestId !== activeDropoffRequestId) {
        return
      }

      if (!otherOptions.filter(option => option.id === content.id).length) {
        otherOptions.push(content)
      }
      const resultsDiv = document.getElementById('dropoff-searchResults')
      const resultsDropdownSet = document.getElementById('dropoff-suggestions')
      const locale = getLocale()

      const itemName = getLocalisedString(locale, content)
      // Use a dropoff-specific DOM id so it cannot collide with pickup result rows, which use
      // their own `option-${id}` ids. The earlier implementation shared ids across both lists,
      // so a pickup row could trick the dropoff renderer into thinking the dropoff row existed.
      const itemID = `dropoff-option-${content.id}`

      // Only check within the dropoff container itself. We only care whether this option has
      // already been rendered in the dropoff list, not whether an element with the same id
      // exists somewhere else in the document.
      if (!resultsDropdownSet.querySelector(`#${itemID}`)) {
        const pItem = document.createElement('div')
        pItem.classList.add('aa-suggestion', 'aa-cursor')
        pItem.id = itemID
        pItem.style.role = 'option'

        let extras = typeof content.county !== 'undefined' && content.county !== '' ? content.county + ', ' : ''
        extras = extras + content.country.name

        // Namespace the inner location id for the same reason as the wrapper id above: keep
        // pickup and dropoff DOM trees independent so duplicate location ids do not clash.
        pItem.innerHTML = `<div id="dropoff-locationID-${content.id}" class="aa-suggestion-location" style="white-space: normal;">
                                      <span>${itemName}</span>
                                      </div>
                                      <div class="aa-suggestion-extra-details" style="white-space: normal;">
                                      <span>${extras}</span>
                                      </div>`

        pItem.addEventListener('click', function () {
          document.getElementById('dropoff-algoliaSearch').value = itemName
          document.getElementById('dropoff-algoliaSearch-data').value = content.id

          resultsDiv.classList.remove('d-block')
          resultsDiv.classList.add('d-none')
        })

        resultsDropdownSet.appendChild(pItem)
      }
    }

    function resetSearchValues() {
      // Clearing the pickup selection must also clear any dropoff choice derived from it,
      // otherwise the form can keep a valid-looking dropoff value that belongs to an older
      // pickup location. `resetDropoffOptions()` also invalidates any late async responses.
      resetDropoffOptions()
      document.getElementById('pickup-algoliaSearch-data').value = ''
      document.getElementById('dropoff-algoliaSearch').value = ''
      document.getElementById('dropoff-algoliaSearch-data').value = ''
    }

    // The dropoff-location wrapper has two shapes in use across search-pane variants:
    // the original hides/shows the whole wrapper via d-none/d-block, while the
    // horizontal search-pane-h variant keeps it visible and just enables/disables the
    // input. `data-dropoff-display="disable"` on the wrapper marks the latter.
    function setDropoffAvailability (available) {
      const resultsContainer = document.getElementById('search-dropoff-location')
      const dropoffSearchInput = document.getElementById('dropoff-algoliaSearch')

      if (resultsContainer.dataset.dropoffDisplay === 'disable') {
        // dropoffSearchInput.disabled = !available
      } else {
        resultsContainer.classList.toggle('d-none', !available)
        resultsContainer.classList.toggle('d-block', available)
      }
    }

    function setSearchValues(item) {
      const locale = getLocale()
      const itemName = getLocalisedString(locale, item)
      // Mint a new request id for this confirmed pickup selection. Everything rendered from
      // this point onward must use this id, so any earlier async requests become stale.
      const requestId = activeDropoffRequestId + 1

      activeDropoffRequestId = requestId
      otherOptions = []
      clearDropoffResults()

      document.getElementById('pickup-algoliaSearch-data').value = item.id
      document.getElementById('dropoff-algoliaSearch').value = itemName
      document.getElementById('dropoff-algoliaSearch-data').value = item.id

      // The pickup location itself is always a valid dropoff option, so seed it immediately
      // before we fetch the remaining linked dropoff locations.
      setDropOff(item, requestId)

      item.dropoff_locations.locations?.forEach(item => {
        // Pass the request id through to every async fetch so only results for this exact
        // pickup selection are allowed to render when the requests complete.
        fetchObject('WoS_' + item, requestId)
      })

      setDropoffAvailability(true)
    }
    function searchLocations(query, numResults, callback) {
      const searchProviders = window.greenmotion.search.providers

      let initialFilters = 'provider:WoS'

      if (typeof searchProviders === 'string') {
        initialFilters = 'provider:' + searchProviders
      } else if (
        Array.isArray(searchProviders) &&
                searchProviders.length > 0
      ) {
        initialFilters = searchProviders.map(x => `provider:${x}`).join(' OR ')
      }

      let filters = initialFilters + ' AND is_active:true'
      const countryId = `${window.countryId}`

      if (window.countryId) {
        filters = `${filters} AND country_id:${countryId}`
      }

      fetchSearchRecords({
        q: query,
        per_page: numResults,
        filters: filters,
      })
        .then(hits => {
          const resultsDiv = document.getElementById('searchResults')
          const resultsDropdownSet = document.getElementById('searchDataset')

          resultsDropdownSet.innerHTML = ''

          if (hits.length > 0) {
            if (typeof callback === 'function') {
              callback(hits[0])
            }

            results = hits

            hits.forEach(item => {
              const pItem = document.createElement('div')
              const locale = getLocale()
              const itemName = getLocalisedString(locale, item)

              pItem.classList.add('aa-suggestion', 'aa-cursor')
              pItem.id = `option-${item.id}`
              pItem.style.role = 'option'

              let extras = typeof item.county !== 'undefined' && item.county !== '' ? item.county + ', ' : ''
              extras = extras + item.country.name

              pItem.innerHTML = `<div id="locationID-${item.id}" class="aa-suggestion-location" style="white-space: normal;">
                                              <span>${itemName}</span>
                                          </div>
                                          <div class="aa-suggestion-extra-details" style="white-space: normal;">
                                              <span>${extras}</span>
                                        </div>`

              pItem.addEventListener('click', function () {
                document.getElementById('pickup-algoliaSearch').value = itemName

                setSearchValues(item)

                if (resultsDiv.classList.contains('d-block')) {
                  resultsDiv.classList.remove('d-block')
                  resultsDiv.classList.add('d-none')
                }
              })

              resultsDropdownSet.appendChild(pItem)
            })
          } else if (typeof callback === 'function') {
            callback(null)
          }
        })
        .catch(error => {
          console.error('There was a problem with the search operation:', error.message)

          if (typeof callback === 'function') {
            callback(null)
          }
        })
    }

    function getLocale() {
      let selectedLanguage = 'en'

      if (
        typeof window.language !== 'undefined' &&
                typeof window.language.accept_language === 'string' &&
                window.language.accept_language.length === 2
      ) {
        selectedLanguage = window.language.accept_language
      }

      return selectedLanguage
    }

    function getLocalisedString(locale, item) {
      if (!item) {
        return ''
      }

      if (typeof item.localisations === 'undefined' || item.localisations === null) {
        return item.name || ''
      }

      return typeof item.localisations[locale] !== 'undefined' ?
        item.localisations[locale].name :
          (item.name || '')
    }

    function convertTimeTo24HourFormat(time12h) {
      // Split the time string into hours, minutes, and AM/PM
      var timeParts = time12h.split(' ')
      var time = timeParts[0]
      var period = timeParts[1]

      // Split the time into hours and minutes
      var timeSplit = time.split(':')
      var hours = parseInt(timeSplit[0])
      var minutes = parseInt(timeSplit[1])

      // If it's PM and not already 12 PM, add 12 hours
      if (period === 'PM' && hours !== 12) {
        hours += 12
      }

      // If it's AM and 12 AM, set hours to 0
      if (period === 'AM' && hours === 12) {
        hours = 0
      }

      // Format hours and minutes into 24-hour format
      var hours24 = hours < 10 ? '0' + hours : hours
      var minutes24 = minutes < 10 ? '0' + minutes : minutes

      // Return the time in 24-hour format
      return hours24 + ':' + minutes24
    }

    function searchListeners() {
      const searchForm = document.getElementById('algolia-search-form')
      if (searchForm) {
        searchForm.addEventListener('submit', function (e) {
          e.preventDefault()

          const button = document.getElementById('algolia-submit-btn')
          setUpBtn(button)

          let data = {
            cancel_donation: false,
            source_id: window.site_source_id,
            // currency: window.defaultCurrency, // Not sending this anymore, it was always GBP
            force_user_location: 'GB',
            locale: window.language.accept_language,
            start_date: isValidDate(document.getElementById('pickup-date-value').value),
            start_time: convertTimeTo24HourFormat(document.getElementById('pickup-time-value').value),
            end_date: isValidDate(document.getElementById('dropoff-date-value').value),
            end_time: convertTimeTo24HourFormat(document.getElementById('dropoff-time-value').value),
            pickup_location_id: isValidLocation(document.getElementById('pickup-algoliaSearch-data').value),
            dropoff_location_id: isValidLocation(document.getElementById('dropoff-algoliaSearch-data').value),
            age: isValidAge(document.getElementById('age').value),
            referral_parameters: JSON.stringify(window.referral_parameters || {})
          }

          const visitorId = getCookie('experiment_visitor_id')
          if (visitorId) {
            data.visitor_id = visitorId
          }

          if (document.getElementById('promo-code').value && document.getElementById('promo-code').value != '') {
            data.promo_code = document.getElementById('promo-code').value
          }

          //console.log('Search Data:', data);

          formSubmit(
            data,
            window.core_api_endpoint + 'api/quotes',
            window.bookingUrl + 'quotes/',
            'id',
            button
          )
        })
      }
      const bookingForm = document.getElementById('booking-search-form')
      if (bookingForm) {
        bookingForm.addEventListener('submit', function (e) {
          e.preventDefault()

          const button = document.getElementById('booking-submit-btn')
          setUpBtn(button)

          const urlPreappend = 'guest' // window.authenticated ? 'user' : 'guest'; user will be needed when booking mods is active.

          formSubmit(
            {
              booking_reference: isValidBookingReference(document.getElementById('booking-search-ref').value),
              last_name: isValidLastName(document.getElementById('booking-search-last-name').value),
            },
            window.core_api_endpoint + 'api/find-booking',
            window.bookingUrl + urlPreappend + '/bookings/',
            'booking_reference',
            button
          )
        })
      }

      const bookNowButton = document.querySelector('.search-pane-link')
      if (bookNowButton) {
        bookNowButton.addEventListener('click', function (e) {
          clearErrors()
        })
      }
    }

    function fetchLocations(locationId) {
      return new Promise((resolve, reject) => {
        fetchData(window.core_api_endpoint + `api/locations?include=country&location_id=${locationId}`)
          .then(data => {
            resolve(data)

            return data
          })
          .catch(error => {
            console.error('An error occurred:', error)
          })
      })
    }

    async function setLocationParams() {
      const queryString = window.location.search.substring(1)
      const paramPairs = queryString.split('&')
      const puidPair = paramPairs.find(pair => {
        const [key] = pair.split('=')
        return key === 'puid'
      })
      const duidPair = paramPairs.find(pair => {
        const [key] = pair.split('=')
        return key === 'duid'
      })

      for (const pair of paramPairs) {
        const [key, value] = pair.split('=')
        if (key !== undefined && value !== undefined) {
          if (key === 'puid') {
            await fetchLocations(value).then(data => {
              showPickup(data, value)
              if (!duidPair) {
                showDropoff(data, value)

                displayDropofflocations(data[0])
              }
            })
          }

          if (key === 'duid') {
            if (puidPair) {
              await fetchLocations(value).then(data => {
                showDropoff(data, value)
              })
            }
          }
        }
      }
    }

    function displayDropofflocations(data) {
      for (const location of data.dropoff_locations.locations) {
        fetchLocations(location).then(data => {
          setDropOff(data[0])
        })
      }
    }

    function showPickup(data, value) {
      document.getElementById('pickup-algoliaSearch').value = data[0].name
      document.getElementById('pickup-algoliaSearch-data').value = value
    }

    function showDropoff(data, value) {
      document.getElementById('dropoff-algoliaSearch').value = data[0].name
      document.getElementById('dropoff-algoliaSearch-data').value = value

      setDropoffAvailability(true)
    }

    function hideDropoff(data, value) {
      setDropoffAvailability(false)
    }

    async function setPromoCode() {
      const queryString = window.location.search.substring(1)
      const paramPairs = queryString.split('&')
      const promoPair = paramPairs.find(pair => {
        const [key] = pair.split('=')
        return key === 'promo'
      })

      for (const pair of paramPairs) {
        const [key, value] = pair.split('=')
        if (key !== undefined && value !== undefined) {
          if (key === 'promo') {
            if (promoPair) {
              document.getElementById('promo-code').value = value

              document.getElementById('promo-check').checked = true
              toggleOptions(document.querySelector('#promo-code-input'))
            }
          }
        }
      }
    }

    function setSearchFromLocationPage() {
      if (document.getElementById('pickup-algoliaSearch-data').value && document.getElementById('dropoff-algoliaSearch-data').value) {
        const locationId = document.getElementById('pickup-algoliaSearch-data').value

        fetchLocations(locationId).then(data => {
          const location = data[0]

          // Add the pickup location to the dropoff locations list
          fetchObject('WoS_' + location.id)

          // Add any other dropoff locations to the dropoff locations list
          location.dropoff_locations.locations?.forEach(item => {
            fetchObject('WoS_' + item)
          })

          if (location) {
            document.getElementById('pickup-algoliaSearch').value = location.name
            document.getElementById('dropoff-algoliaSearch').value = location.name
          }
        })
      }
    }

    function setSearchFromCookie() {

      const searchFormInitCookie = getCookie('search_form_init')
      let searchFormInit = null

      if (!searchFormInitCookie) {
        return
      }

      try {
        searchFormInit = JSON.parse(decodeURIComponent(searchFormInitCookie))
      } catch (e) {
        return
      }

      if (!searchFormInit) {
        return
      }

      //
      //  PICK UP LOCATION
      //
      if (searchFormInit.pick_up_location_id) {
        fetchLocations(searchFormInit.pick_up_location_id).then(data => {
          console.log('Pickup Location Data:', data)
          const pick_up_location = data[0]

          fetchObject('WoS_' + pick_up_location.id)          // Add the pickup location to the dropoff locations list
          pick_up_location.dropoff_locations.locations?.forEach(item => { fetchObject('WoS_' + item) }) // Add any other dropoff locations to the dropoff locations list    })

          document.getElementById('pickup-algoliaSearch').value = pick_up_location.name

          // Un-hide the dropoff location search results
          setDropoffAvailability(true)
        })
      }

      //
      //  DROP OFF LOCATION
      //
      if (searchFormInit.drop_off_location_id) {
        fetchLocations(searchFormInit.drop_off_location_id).then(data => {
          const drop_off_location = data[0]

          document.getElementById('dropoff-algoliaSearch').value = drop_off_location.name
        })
      }

      //
      //  ERRORS
      //
      if (searchFormInit.error) {
        const errors = []

        console.log('Search form error:', searchFormInit.error)

        errors.push(searchFormInit.error)
        displayErrors(errors)
      }

      //
      //  PICK UP DATE and TIME
      //  DROP OFF DATE and TIME
      //
      // (Handled in _layout.twig)

      //
      //  AGE
      //
      if (searchFormInit.age) {
        document.getElementById('age').value = searchFormInit.age
        document.getElementById('age-check').checked = false
        toggleOptions(document.querySelector('#age-input'))
      }

      //
      //  PROMO CODE
      //
      if (searchFormInit.promo_code) {
        document.getElementById('promo-code').value = searchFormInit.promo_code
        document.getElementById('promo-check').checked = true
        toggleOptions(document.querySelector('#promo-code-input'))
      }


    }

    fetchCountryId()
    getFranchise()
    setLocationParams()
    setPromoCode()
    searchListeners()
    checkInputSetup()
    setUpSearchInputs()
    showMoreResults()
    setSearchFromLocationPage()
    setSearchFromCookie()
  };

  SearchPane.init()
})
